import Vue from 'vue';
import * as types from '@/store/mutation-types';

export default {
  [types.setCompanyProperties](state, update) {
    Object.assign(update.updateCompany, update.newCompanyProperties);
  },
  [types.setCompanyList](state, list) {
    Vue.set(state, 'companies', list);
  },
  [types.addCompany](state, update) {
    if (!state.companies[update.newCompany._id]) {
      Vue.set(state.companies, update.newCompany._id, update.newCompany);
    }
  },
  [types.deleteCompany](state, { company }) {
    if (state.companies[company._id]) {
      Vue.delete(state.companies, company._id);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/company/companyMutations.js